// Reducer de indicadores compartido por las planillas de Cauciones y Pases.
// Ambas comparten la misma forma (operacion Colocadora/Tomadora, moneda, monto,
// montoOperado, estado), así que los totales se calculan igual. Extraído de
// CaucionesTab para reutilizarlo sin duplicar la lógica.

import { MONEDA_BUCKETS, bucketDeMoneda } from '../constants/monedas';

const ESTADOS_VALIDOS = ['Pendiente', 'En Proceso', 'Hecha'];
const ESTADOS_OPERADOS = ['En Proceso', 'Hecha'];

const totalesVacios = () => ({
  tomadorasTotales: 0,
  tomadorasOperadas: 0,
  colocadorasTotales: 0,
  colocadorasOperadas: 0,
});

/**
 * Totales por operación (Tomadora/Colocadora) y estado, agrupados por moneda.
 * @param {Array} items - cauciones o pases
 * @returns {{ ARS: totales, USD: totales, CABLE: totales }} donde cada `totales`
 *   es { tomadorasTotales, tomadorasOperadas, colocadorasTotales, colocadorasOperadas }
 */
export const computeKpiTotales = (items) => {
  const acc = MONEDA_BUCKETS.reduce((res, bucket) => ({ ...res, [bucket]: totalesVacios() }), {});

  (items || []).forEach(item => {
    const bucket = acc[bucketDeMoneda(item.moneda)];
    const monto = parseFloat(item.monto) || 0;
    const montoOperado = parseFloat(item.montoOperado) || 0;
    const esValido = ESTADOS_VALIDOS.includes(item.estado);
    const esOperado = ESTADOS_OPERADOS.includes(item.estado);

    if (item.operacion === 'Tomadora') {
      if (esValido) bucket.tomadorasTotales += monto;
      if (esOperado) bucket.tomadorasOperadas += montoOperado;
    } else if (item.operacion === 'Colocadora') {
      if (esValido) bucket.colocadorasTotales += monto;
      if (esOperado) bucket.colocadorasOperadas += montoOperado;
    }
  });

  return acc;
};
